module.exports = __webpack_public_path__ + "pc/img/swiper_00.b36702ff.png";